import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, StarIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const productImage = 'https://cdn.magicpatterns.com/uploads/jwH8FDGPeHkwjNq8VjNv3K/seguridad_e_higiene_(4).png';
export function Hero() {
  return <section className="relative overflow-hidden bg-white px-4 pb-16 pt-10 sm:pb-20 sm:pt-14" data-id="element-133">
      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55
      }} data-id="element-135">
          <p className="mb-5 inline-flex rounded-full border border-navy/20 bg-soft px-3 py-1 text-xs font-semibold tracking-wide text-navy" data-id="element-136">
            DANCE FITNESS INSTRUCTOR PRO™
          </p>
          <h1 className="font-display text-4xl font-bold leading-[1.08] tracking-tight text-navy sm:text-5xl md:text-6xl" data-id="element-137">
            Solve a full year of classes{' '}
            <span className="orange-text" data-id="element-138">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.14,
        duration: 0.55
      }} className="relative my-6 w-full max-w-[310px] sm:my-8 sm:max-w-md" data-id="element-139">
          <div className="absolute inset-x-10 bottom-3 h-8 rounded-full bg-navy/10 blur-xl" aria-hidden="true" data-id="element-140" />
          <img src={productImage} alt="Dance Fitness Instructor Pro complete 7-in-1 ready-to-teach system" className="relative mx-auto w-full object-contain drop-shadow-[0_22px_26px_rgba(11,31,58,.2)]" data-id="element-141" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.28,
        duration: 0.5
      }} data-id="element-142">
          <p className="mx-auto mb-6 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg" data-id="element-143">
            The complete ready-to-teach system for dance fitness instructors.
            Save hours of planning, deliver more dynamic classes, and teach with
            total confidence.
          </p>
          <CheckoutButton data-id="element-144">YES, I WANT MY SYSTEM NOW</CheckoutButton>
          <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-navy" data-id="element-145">
            {['7 professional modules', '5 premium bonuses included', 'Immediate access by email'].map(item => <span key={item} className="flex items-center gap-1.5" data-id="element-146">
                <CheckCircle2Icon size={15} className="text-orange" data-id="element-147" />
                {item}
              </span>)}
          </div>
          <p className="mt-4 flex items-center justify-center gap-1 text-xs font-medium text-navy" data-id="element-148">
            {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={13} fill="currentColor" className="text-orange" data-id="element-149" />)}
            <span className="ml-1" data-id="element-150">
              4.9/5 — Verified Professional Reviews · 7-Day Guarantee
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}